import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice, gridSlice } from 'Modules'
import { ResponseCatalog } from 'Models'
import {
	BgBlackList,
	bgBlackListApi,
	BgBlackListNs,
	bgBlackListSelector,
	bgBlackListSlice,
	bgRequestApi,
	BgRequestNs,
	bgRequestSelector,
	bgRequestSlice,
	Calendar,
} from 'Pages/ibro'

function* getBlackList(action: BgBlackListNs.GetBlackList) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		const res = yield* call(bgBlackListApi.getBlackList, params)
		const items = new ResponseCatalog<BgBlackList>(res)
		if (!clear && params.page !== 1) {
			const oldItems = yield* select(bgBlackListSelector.selectBlackList)
			items.entries = oldItems.concat(items.entries)
		}
		yield* put(bgBlackListSlice.actions.setBlackList(items))
		yield* put(bgBlackListSlice.actions.setRequestParams(params))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* createBlackListItem(action: BgBlackListNs.CreateBlackListItem) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(bgBlackListApi.createBlackList, action.payload)
		const entries = yield* select(bgBlackListSelector.selectBlackList)
		entries.push(res)
		yield* put(
			bgBlackListSlice.actions.setBlackList(
				new ResponseCatalog<BgBlackList>({ entries: [...entries] })
			)
		)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* updateBlackListItem(action: BgBlackListNs.UpdateBlackListItem) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(bgBlackListApi.updateBlackList, action.payload)
		const items = yield* select(bgBlackListSelector.selectBlackList)
		const entries = items.map((item) => (item.id === res.id ? res : item))
		yield* put(bgBlackListSlice.actions.setBlackList(new ResponseCatalog<BgBlackList>({ entries })))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* deleteBlackListItem(action: BgBlackListNs.DeleteBlackListItem) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { id } = action.payload
		yield* call(bgBlackListApi.deleteBlackList, id)
		const items = yield* select(bgBlackListSelector.selectBlackList)
		const entries = items.filter((item) => item.id !== id)
		yield* put(bgBlackListSlice.actions.setBlackList(new ResponseCatalog<BgBlackList>({ entries })))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}
function* getAllCalendars(action: BgRequestNs.GetCalendarList) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { params, clear, callback } = action.payload
		const res = yield* call(bgRequestApi.getCalendarList, params)
		const items = new ResponseCatalog<Calendar>(res)
		if (!clear && params.page !== 1) {
			const oldItems = yield* select(bgRequestSelector.selectCalendarList)
			items.entries = oldItems.concat(items.entries)
		}
		yield* put(bgRequestSlice.actions.setCalendarList(items))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* bgBlackListSaga() {
	yield* takeLatest(bgBlackListSlice.actions.getBlackList.type, getBlackList)
	yield* takeLatest(bgBlackListSlice.actions.createBlackListItem.type, createBlackListItem)
	yield* takeLatest(bgBlackListSlice.actions.updateBlackListItem.type, updateBlackListItem)
	yield* takeLatest(bgBlackListSlice.actions.deleteBlackListItem.type, deleteBlackListItem)
	yield* takeLatest(bgRequestSlice.actions.getCalendarList.type, getAllCalendars)
}
